/**
 * Can replace data set
 * @param {Backbone.View} v View instance
 */
export const canReplaceDataSet = (v: any) => {
	// Only CSV sourced dataSets can be replaced
	return v.model.get('source') === 'CSV File';
};
